export default __webpack_public_path__ + "static/media/union~xpyKdxFa.eae6d0c4.svg";